module.exports = [
    {name: "Eastern Time", code: "EST", gmt: "(UTC-05:00)"},
    {name: "Central Time", code: "CST", gmt: "(UTC-06:00)"},
    {name: "Mountain Time", code: "MCT", gmt: "(UTC-07:00)"},
    {name: "Pacific Time", code: "PST", gmt: "(UTC-08:00)"},
    {name: "Alaska Time", code: "AKST", gmt: "(UTC-09:00)"},
    {name: "Hawaii Time", code: "HST", gmt: "(UTC-10:00)"},
  ];